export default "__VITE_ASSET__Cd3IrDh6__"